import React from "react";
import { ToggleGroup } from "@design-system/ToggleGroup/ToggleGroup";
import type { DatePickerSelectionMode } from "./DatePicker.types";
import styles from "./DatePicker.module.scss";

const getModeLabel = (mode: DatePickerSelectionMode) => {
    if (mode === "monthRange") {
        return "Month range";
    }
    return mode === "day" ? "Day" : `${mode[0]?.toUpperCase()}${mode.slice(1)}`;
};

export const DatePickerModeSwitcher = ({
    mode,
    availableModes,
    onModeChange,
}: {
    mode: DatePickerSelectionMode;
    availableModes: readonly DatePickerSelectionMode[];
    onModeChange?: (mode: DatePickerSelectionMode) => void;
}) => (
    <div className={styles.periodSwitcher}>
        <ToggleGroup.Root
            value={mode}
            onValueChange={(nextMode) => {
                if (nextMode) {
                    onModeChange?.(nextMode);
                }
            }}
            size="sm"
            className={styles.periodSwitcherRoot}
        >
            {availableModes.map((availableMode) => (
                <ToggleGroup.Item
                    key={availableMode}
                    value={availableMode}
                    className={styles.periodSwitcherItem}
                >
                    {getModeLabel(availableMode)}
                </ToggleGroup.Item>
            ))}
        </ToggleGroup.Root>
    </div>
);
